// extracted by mini-css-extract-plugin
export default {"searchBox":"Search_searchBox__j8Wlz","inputSearch":"Search_inputSearch__dDmYq"};